import { FileCheck } from 'lucide-react';
import { useMyCompetencyEvidence } from '@/api/competency-evidence';
import { EvidenceActivityCard } from './evidence-activity-card';

// The colaborador's evidence/certificate activities. Hidden entirely when their
// positions have no evidence activities (keeps the competency page uncluttered).
export function MyCertificatesSection() {
  const { data, isLoading } = useMyCompetencyEvidence();
  const activities = data ?? [];
  if (isLoading || activities.length === 0) return null;

  return (
    <section className="space-y-4">
      <div className="flex items-center gap-2">
        <FileCheck className="h-5 w-5 text-primary" />
        <h2 className="text-lg font-semibold text-foreground">Mis Certificados</h2>
      </div>
      <div className="grid gap-3 sm:grid-cols-2">
        {activities.map((a) => (
          <EvidenceActivityCard key={a.id} activity={a} />
        ))}
      </div>
    </section>
  );
}
